<template>
  <router-view />
</template>

<script>
import store, { name as moduleName } from '@/modules/trainingHistory/store';
export default {
  name: 'TrainingHistoryWrapper',
  created() {
    if (this.$store.state[moduleName] == undefined) {
      this.$store.registerModule(moduleName, store);
    }
  },
  destroyed() {
    this.$store.commit(`${moduleName}/dispose`);
  },
};
</script>
